import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { getActiveBannerByCodeApi } from "../../api/api";
import Searchhome from "./Search";
import Category from "./Category";
import FeaturedEvent from "./FeaturedEvent";
import ChooseUs from "./ChooseUs";
import City from "./City";
import Counts from "./Counts";
import LatestBlog from "./LatestBlog";
import Sponsors from "./Sponser";
import SpinLoading from "../../components/spinLoading/SpinLoading";

const Home = () => {
  const tablet = useMediaQuery({ query: "(max-width: 992px)" });

  const [desktopList, setDesktopList] = useState([]);
  const [mobileList, setMobileList] = useState([]);
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true)
        const { data } = await getActiveBannerByCodeApi("principal23");
        const banner = data?.info || null;

        if (banner?.isVisible) {
          // 🔑 ahora vienen como arrays de string
          setDesktopList(Array.isArray(banner.desktop) ? banner.desktop : []);
          setMobileList(Array.isArray(banner.mobile) ? banner.mobile : []);
        } else {
          setDesktopList([]);
          setMobileList([]);
        }
      } catch (err) {
        console.error("No se pudo cargar el banner principal", err);
        setDesktopList([]);
        setMobileList([]);
      } finally {
        setIsLoading(false)
      }
    })();
  }, []);
  if (isLoading) return <SpinLoading />;
  return (
    <>
      <div style={{ padding: 0 }}>
        {/* Le pasamos las listas al hero */}
        <Searchhome desktopList={desktopList} mobileList={mobileList} />
      </div>

      <div className="pading150" style={{ backgroundColor: "transparent" }}>
        <Category />
      </div>
      <div style={{ backgroundColor: "transparent" }}>
        <FeaturedEvent />
      </div>
      <div className="pading150">
        <ChooseUs />
      </div>
      <div style={{ backgroundColor: "transparent" }}>
        <City />
      </div>
      <div className="pading150" style={{ backgroundColor: "#bac819" }}>
        <Counts />
      </div>
      <div className={tablet ? "" : "pading150"} style={{ backgroundColor: "transparent" }}>
        <LatestBlog />
      </div>
      <div style={{ backgroundColor: "transparent" }}>
        <Sponsors />
      </div>
    </>
  );
};

export default Home;
